module.exports = __webpack_public_path__ + "static/media/ls-6.eed557ad.jpg";